import * as React from 'react';
import Dialog, {DialogProps} from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent, {DialogContentProps} from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import AppDialogFooter, {AppDialogFooterProps} from './AppDialogFooter';
import {Box, BoxProps, Tooltip} from '@mui/material';
import {CloseCircle} from 'iconsax-react';
import {AppIconButton} from 'components/buttons';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export interface AppDialogProps extends Omit<DialogProps, 'title' | 'onClick' | 'children'> {
    open: boolean;
    onCloseDialog: () => void;
    title?: string | React.ReactNode;
    children: React.ReactNode;
    footer?: React.ReactNode;
    dialogContentProps?: DialogContentProps;
    footerProps?: AppDialogFooterProps;
    dialogContainerProps?: Omit<BoxProps, 'children'>;
    isForm?: boolean;
    onFormSubmit?: any;
    descriptionText?: string;
}

export const AppDialog: React.FC<AppDialogProps> = ({
    open,
    onCloseDialog,
    dialogContentProps,
    title,
    children,
    footerProps,
    dialogContainerProps,
    isForm,
    onFormSubmit,
    descriptionText,

    ...props
}) => {
    let {footer} = props;
    if (!footer && footerProps) {
        footer = <AppDialogFooter {...footerProps} />;
    }
    return (
        <>
            <Dialog open={open} {...props}>
                <Box
                    {...dialogContainerProps}
                    component={isForm ? 'form' : 'div'}
                    onSubmit={isForm ? onFormSubmit : undefined}
                    style={{overflow: 'hidden'}}
                >
                    <DialogTitle>
                        <Box display={'flex'}>
                            {title}
                            {descriptionText && (
                                <Box ml={0.5}>
                                    <Tooltip title={descriptionText} placement="top" arrow>
                                        <HelpOutlineIcon color="primary" fontSize="small" />
                                    </Tooltip>
                                </Box>
                            )}
                        </Box>

                        <AppIconButton
                            aria-label="close"
                            onClick={() => {
                                onCloseDialog();
                            }}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: theme => theme.palette.grey[500],
                            }}
                        >
                            <CloseCircle size={28} />
                        </AppIconButton>
                    </DialogTitle>

                    <DialogContent
                        {...dialogContentProps}
                        style={{maxHeight: 'calc(100vh - 100px)', overflowY: 'auto'}}
                    >
                        {children}
                    </DialogContent>
                    <DialogActions>{footer}</DialogActions>
                </Box>
            </Dialog>
        </>
    );
};

export default AppDialog;
